import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { useDictionary } from 'bdvp-common/src/hooks/config';

import ThumbnailRadio, { Label } from './ThumbnailRadio';
import FieldLabel from './FieldLabel';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

const RadioGroup = styled.fieldset`
    border: none;
    margin: 0 0 30px;
    padding: 0;
`;

const Thumbs = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0px -7.5px;

    ${media.mdmin`
        margin: 0px;

        ${Label}:nth-of-type(5n+1) {
            margin-left: 0px;
        }

        ${Label}:nth-of-type(5n) {
            margin-right: 0px;
        }
    `}
`;

const ThumbnailField = (props) => {

    const {
        dictionary,
        reel,
        formState,
        handleChange,
    } = props;

    const {
        choose_a_thumbnail: chooseAThumbnail = 'Choose a Thumbnail',
    } = useDictionary();

    return (
        <RadioGroup>
            <FieldLabel as={'legend'}>{chooseAThumbnail}</FieldLabel>
            <Thumbs>
                {reel?.reelClips?.map((clip) => (
                    <ThumbnailRadio
                        key={clip.mediaId}
                        clip={clip}
                        formState={formState}
                        handleChange={handleChange}
                    />
                ))}
            </Thumbs>
        </RadioGroup>
    );

};

ThumbnailField.propTypes = {
    reel: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default ThumbnailField;
